export const FORM_REGISTRAR_EMPRESA = {
    nombre: "",
    telefono: "",
    correo: "",
    empresa: "",
};